export default "__VITE_ASSET__445746b0__"